export class CpfInUseError extends Error {
  constructor() {
    super('CPF já cadastrado')
    this.name = 'CpfInUseError'
  }
}
